module.exports = __webpack_public_path__ + "static/img/CL-get-involved-24.a874fce.png";


//////////////////
// WEBPACK FOOTER
// ./static/CL-get-involved-24.png
// module id = ESLV
// module chunks = 1